import React, { memo } from 'react';
import { Text, View, Image, StyleSheet } from 'react-native';

import { COLOR, FONT, FONT_SIZE, __WEB__ } from '../../../constants/styles';

import ClipboardTouchable from '../clipboard_touchable';
import ParsedText from '../linking/parsed_text';
import I18n from '../../../I18n';

const IconRow = memo((props) => {
  const { label, value, imageSource, topBorder, bottomBorder, iconStyle } = props;
  const borderTopWidth = topBorder ? 1 : 0;
  const borderBottomWidth = bottomBorder === false ? 0 : 1;
  const borderStyle = { borderTopWidth, borderBottomWidth };

  return (
    <View style={[styles.container, borderStyle]}>
      <ClipboardTouchable style={[styles.touchableContainer]} text={value}>
        <Image style={[styles.icon, iconStyle || null]} source={imageSource} resizeMode="contain" />
        <Text style={styles.labelText}>{label}</Text>
        <ParsedText style={styles.valueText} renderText={props.renderText}>
          {value || I18n.t('none')}
        </ParsedText>
        <View style={{ width: __WEB__ ? 35 : 25 }} />
      </ClipboardTouchable>
    </View>
  );
});

const styles = StyleSheet.create({
  container: {
    paddingLeft: __WEB__ ? 35 : 25,
    borderColor: COLOR.accent,
  },
  touchableContainer: {
    flexDirection: 'row',
    alignItems: 'center',
    height: 50,
  },
  icon: {
    width: 17,
    height: 16,
  },
  labelText: {
    ...FONT.regular,
    fontSize: FONT_SIZE.large,
    color: COLOR.text,
    marginLeft: 23,
  },
  valueText: {
    flex: 1,
    ...FONT.light,
    fontSize: FONT_SIZE.small,
    color: COLOR.text,
    marginRight: 5,
    textAlign: 'right',
  },
});

IconRow.displayName = 'IconRow';
export default IconRow;
